import React from 'react';
import { useAppSelector } from '@global/store/hooks';
import { CountryService } from '@global/utils/CountryService';

import { Address } from '@global/types/types';
import { CommonCheckbox } from '@global/components/CommonCheckbox';
import { countriesSelector } from '@global/store/slices/country/countrySelector';

type AddressProps = {
  address: Address;
  isSelected: boolean;
  onSelect: () => void;
};

const sanitizeStr = (srt: string): string => (srt === 'null' ? '' : srt);

export const AddressItem = ({
  address,
  onSelect,
  isSelected,
}: AddressProps) => {
  const countries = useAppSelector(countriesSelector);
  const sanitizedAddress = Object.entries(address).reduce(
    (acc, [key, value]) => ({ ...acc, [key]: sanitizeStr(value) }),
    {} as Address
  );

  const country = CountryService.getCountryByIsoCode(
    countries,
    address.wCountry
  );

  return (
    <address className="address">
      <CommonCheckbox checked={isSelected} toggle={onSelect} />
      <ul className="address__info">
        <li className="address__row">
          {sanitizedAddress.wFirstName} {sanitizedAddress.wLastName}
        </li>
        <li className="address__row">
          {sanitizedAddress.upaLine1} {sanitizedAddress.upaLine2}
        </li>
        <li className="address__row">
          {sanitizedAddress.upaCity}, {sanitizedAddress.gadStateOrProvince}{' '}
          {sanitizedAddress.upaPostcode}
        </li>
        <li className="address__row">{sanitizeStr(country?.name)}</li>
        <li className="address__row">{sanitizedAddress.upaPhoneNumber}</li>
      </ul>
    </address>
  );
};
